import apiClient from '../connections/api'

export default {
    getRoles: () => {
        return apiClient.get('/roles')
    },
    createRole: (roleData) => {
        return apiClient.post('/roles', roleData)
    },
    updateRole: (roleId, roleData) => {
        return apiClient.patch(`/roles/${roleId}`, roleData)
    }
}
